import { z } from "zod";

type AnyZodObject = z.ZodObject<any, any, any, any>;

export function splitBySchemaShape<S extends AnyZodObject>(
  schema: S,
  values: unknown
) {
  const parsed = schema.parse(values) as Record<string, unknown>;

  const shapeKeys = new Set(Object.keys(schema.shape));

  const defined: Record<string, unknown> = {};
  const details: Record<string, unknown> = {};

  for (const [k, v] of Object.entries(parsed)) {
    (shapeKeys.has(k) ? defined : details)[k] = v;
  }

  return { defined: defined as z.infer<S>, details };
}
